function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { StreamingProtocol } from '../../../core/player/playout-data';
import { sdkLogger } from '../../../logger';
import { FileExtension } from './stream-proxy.enums';
export { FileExtension } from './stream-proxy.enums';
export var StreamProxy = /*#__PURE__*/ function() {
    "use strict";
    function StreamProxy(config) {
        _class_call_check(this, StreamProxy);
        _define_property(this, "config", void 0);
        _define_property(this, "streamingProtocolToFileExtension", void 0);
        this.config = config;
        var _obj;
        this.streamingProtocolToFileExtension = (_obj = {}, _define_property(_obj, StreamingProtocol.DASH, FileExtension.MPD), _define_property(_obj, StreamingProtocol.HLS, FileExtension.M3U8), _obj);
        sdkLogger.info("Using stream proxy: ".concat(config.proxyHost));
    }
    _create_class(StreamProxy, [
        {
            key: "streamPlayoutThroughProxy",
            value: function streamPlayoutThroughProxy(playoutData, opts) {
                // If no protocol is set, defaults to HTTP
                var proxyHost = this.config.proxyHost.startsWith('http') ? this.config.proxyHost : "http://".concat(this.config.proxyHost);
                var maxAudioTracks = this.config.maxAudioTracks ? "&maxAudioTracks=".concat(this.config.maxAudioTracks) : '';
                var maxSubtitleTracks = this.config.maxSubtitleTracks ? "&maxSubtitleTracks=".concat(this.config.maxSubtitleTracks) : '';
                return _object_spread_props(_object_spread({}, playoutData), {
                    cdns: playoutData.cdns.map(function(cdn) {
                        return _object_spread_props(_object_spread({}, cdn), {
                            // File extension added, as some players make assumptions based on this
                            url: "".concat(proxyHost, "/stream-proxy/placeholder.").concat(opts.fileExtension, "?url=").concat(encodeURIComponent(cdn.url), "&originalHost=").concat(encodeURIComponent(proxyHost)).concat(maxAudioTracks).concat(maxSubtitleTracks)
                        });
                    })
                });
            }
        },
        {
            key: "modifyPlayout",
            value: function modifyPlayout(playoutData) {
                var streamingProtocol = playoutData.stream.protocol;
                var fileExtension = this.streamingProtocolToFileExtension[streamingProtocol];
                if (!fileExtension) {
                    return playoutData;
                }
                return this.streamPlayoutThroughProxy(playoutData, {
                    fileExtension: fileExtension
                });
            }
        }
    ]);
    return StreamProxy;
}();

//# sourceMappingURL=stream-proxy.js.map